var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: {
      id: _vm.id,
      modalClass: "modal-import-data",
      headerText: _vm.$t("message.importlotfromexcel"),
      showCloseButton: !_vm.isSubmitted
    },
    on: { onClose: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "container-body" },
              [
                _vm.isRenderContent
                  ? _c("ImportData", {
                      attrs: {
                        columns: _vm.columns,
                        templateLink: _vm.templateLink,
                        invalid: _vm.invalid
                      },
                      on: {
                        "update:invalid": function($event) {
                          _vm.invalid = $event
                        },
                        onChange: _vm.handleChange
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              {
                staticClass:
                  "container-footer w-100 d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://treesoft.io/th/manual/inventory#lot",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("button.learnmore")) +
                        "\n        "
                    ),
                    _c("i", { staticClass: "fas fa-external-link-alt" })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BaseFormAction", {
                      attrs: {
                        textCancel: _vm.$t("button.close"),
                        textSubmit: _vm.$t("button.save"),
                        isSubmitted: _vm.isSubmitted,
                        isHideCloseButton: false,
                        isDisabledSubmit: _vm.isDisabledSaveBtn
                      },
                      on: {
                        onCancel: _vm.handleClose,
                        onSubmit: _vm.handleSubmit
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d3831ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3831ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalImportLot.vue
// module id = null
// module chunks = 